import {
  Column,
  ColumnFilterElementTemplateOptions,
  ColumnProps,
} from 'primereact/column';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import { TFunction } from 'i18next';

import { formatDate, formatDateAndTime } from '@/utils/formatDate';
import InputDateFilter from '@/components/InputDateFilter/InputDateFilter';

import TableDropdownFilter from '@/components/TableDropdownFilter/TableDropdownFilter';

import {
  filterApplyTemplate,
  filterClearTemplate,
  inputTextTemplate,
} from '@/components/Table/Table';
import { TableData } from '@/components/Table/types';
import { getServiceCell } from './getServiceCell';
import { Exchange } from '../types';

export const tableColumns: ColumnProps[] = [
  {
    field: 'playa',
    header: 'Playa',
    filter: true,
    sortable: true,
    showFilterMenu: true,
  },
  {
    field: 'armador',
    header: 'Armador',
    sortable: true,
    showFilterMenu: true,
    body: (rowData: Exchange) => getServiceCell(rowData.armador),
  },
  {
    field: 'contenedor',
    header: 'Contenedor',
    filter: true,
    showFilterMenu: true,
    style: { fontWeight: 'bold' },
  },
  {
    field: 'tipoDeContenedor',
    header: 'Ti',
    filter: true,
    showFilterMenu: true,
    sortable: true,
  },
  {
    field: 'tamano',
    header: 'Ta',
    filter: true,
    showFilterMenu: true,
    sortable: true,
  },
  {
    field: 'fechaAbierto',
    header: 'Abierto',
    body: (rowData: Exchange) => formatDateAndTime(rowData.fechaAbierto),
    filter: true,
    showFilterMenu: true,
    sortable: true,
  },
  {
    field: 'booking',
    header: 'Booking',
    filter: true,
    showFilterMenu: true,
    sortable: true,
  },
  {
    field: 'matricula',
    header: 'Matricula',
    filter: true,
    showFilterMenu: true,
    sortable: true,
  },
  {
    field: 'precinto1',
    header: 'Precinto 1',
    filter: true,
    showFilterMenu: true,
    sortable: true,
  },
  {
    field: 'precinto2',
    header: 'Precinto 2',
    filter: true,
    showFilterMenu: true,
    sortable: true,
  },
  {
    field: 'precinto3',
    header: 'Precinto 3',
    filter: true,
    showFilterMenu: true,
    sortable: true,
  },
  {
    field: 'precinto4',
    header: 'Precinto 4',
    filter: true,
    showFilterMenu: true,
    sortable: true,
  },
  {
    field: 'motivo',
    header: 'Ta',
    filter: true,
    showFilterMenu: true,
    sortable: true,
  },
  {
    field: 'viajeImport',
    header: 'Viaje',
    filter: true,
    showFilterMenu: true,
    sortable: true,
  },
  {
    field: 'origen',
    header: 'Origen',
    filter: true,
    showFilterMenu: true,
    sortable: true,
  },
  {
    field: 'fechaLlegada',
    header: 'fechaLlegada',
    body: (rowData: Exchange) => formatDate(rowData.fechaLlegada),
    filter: true,
    showFilterMenu: true,
    sortable: true,
  },
  {
    field: 'imoImport',
    header: 'IMO',
    filter: true,
    showFilterMenu: true,
    sortable: true,
  },
  {
    field: 'viajeExport',
    header: 'viajeExport',
    filter: true,
    showFilterMenu: true,
    sortable: true,
  },
  {
    field: 'destino',
    header: 'destino',
    filter: true,
    showFilterMenu: true,
    sortable: true,
  },
  {
    field: 'fechaSalida',
    header: 'fechaSalida',
    body: (rowData: Exchange) => formatDate(rowData.fechaSalida),
    filter: true,
    showFilterMenu: true,
    sortable: true,
  },
  {
    field: 'exportador',
    header: 'Exportador',
    filter: true,
    showFilterMenu: true,
    sortable: true,
  },
  {
    field: 'imoExport',
    header: 'Imo Export',
    filter: true,
    showFilterMenu: true,
    sortable: true,
  },
];

export const getHeaderColumnsGroup = (
  translates: TFunction<'Exchanges', undefined>,
  data: Exchange[] | undefined
) => (
  <ColumnGroup>
    <Row>
      <Column
        header="Playa"
        field="playa"
        rowSpan={3}
        sortable
        style={{ borderTopLeftRadius: '16px' }}
        showFilterMenu
        filter
        showFilterMatchModes={false}
        filterApply={filterApplyTemplate}
        filterClear={filterClearTemplate}
        filterElement={inputTextTemplate}
      />

      <Column
        header="Armador"
        field="armador"
        rowSpan={3}
        sortable
        showFilterMenu
        filter
        showFilterMatchModes={false}
        filterApply={filterApplyTemplate}
        filterClear={filterClearTemplate}
        filterElement={inputTextTemplate}
      />
      <Column
        header="Contenedor"
        field="contenedor"
        rowSpan={3}
        sortable
        showFilterMenu
        filter
        showFilterMatchModes={false}
        filterApply={filterApplyTemplate}
        filterClear={filterClearTemplate}
        filterElement={inputTextTemplate}
      />
      <Column
        header="Ti"
        field="tipoDeContenedor"
        rowSpan={3}
        sortable
        showFilterMenu
        filter
        showFilterMatchModes={false}
        filterApply={filterApplyTemplate}
        filterClear={filterClearTemplate}
        filterElement={(options: ColumnFilterElementTemplateOptions) => (
          <TableDropdownFilter
            options={options}
            data={data as TableData}
            fieldName="tipoDeContenedor"
          />
        )}
      />
      <Column
        header="Ta"
        field="tamano"
        rowSpan={3}
        sortable
        showFilterMenu
        filter
        showFilterMatchModes={false}
        filterApply={filterApplyTemplate}
        filterClear={filterClearTemplate}
        filterElement={(options: ColumnFilterElementTemplateOptions) => (
          <TableDropdownFilter
            options={options}
            data={data as TableData}
            fieldName="tamano"
          />
        )}
      />
      <Column
        header="Abierto"
        field="fechaAbierto"
        rowSpan={3}
        sortable
        showFilterMenu
        filter
        showFilterMatchModes={false}
        filterApply={filterApplyTemplate}
        filterClear={filterClearTemplate}
        filterElement={(options: ColumnFilterElementTemplateOptions) => (
          <InputDateFilter options={options} displayMenu />
        )}
        dataType="date"
        filterField="fechaAbierto"
      />
      <Column
        header={translates('booking')}
        field="booking"
        rowSpan={3}
        sortable
        filter
        showFilterMatchModes={false}
        filterApply={filterApplyTemplate}
        filterClear={filterClearTemplate}
        filterElement={inputTextTemplate}
      />
      <Column
        header="Matricula"
        field="matricula"
        rowSpan={3}
        sortable
        filter
        showFilterMatchModes={false}
        filterApply={filterApplyTemplate}
        filterClear={filterClearTemplate}
        filterElement={inputTextTemplate}
      />
      <Column
        header={translates('precinct1')}
        field="precinto1"
        rowSpan={3}
        sortable
        filter
        showFilterMatchModes={false}
        filterApply={filterApplyTemplate}
        filterClear={filterClearTemplate}
        filterElement={inputTextTemplate}
      />
      <Column
        header={translates('precinct2')}
        field="precinto2"
        rowSpan={3}
        sortable
        filter
        showFilterMatchModes={false}
        filterApply={filterApplyTemplate}
        filterClear={filterClearTemplate}
        filterElement={inputTextTemplate}
      />
      <Column
        header={translates('precinct3')}
        field="precinto3"
        rowSpan={3}
        sortable
        filter
        showFilterMatchModes={false}
        filterApply={filterApplyTemplate}
        filterClear={filterClearTemplate}
        filterElement={inputTextTemplate}
      />
      <Column
        header={translates('precinct4')}
        field="precinto4"
        rowSpan={3}
        sortable
        filter
        showFilterMatchModes={false}
        filterApply={filterApplyTemplate}
        filterClear={filterClearTemplate}
        filterElement={inputTextTemplate}
      />
      <Column
        header={translates('reason')}
        field="motivo"
        rowSpan={3}
        sortable
        showFilterMenu
        filter
        showFilterMatchModes={false}
        filterApply={filterApplyTemplate}
        filterClear={filterClearTemplate}
        filterElement={inputTextTemplate}
      />
    </Row>
    <Row>
      <Column header={translates('import')} colSpan={4} />
      <Column
        header={translates('export')}
        colSpan={5}
        style={{ borderTopRightRadius: '16px' }}
      />
    </Row>
    <Row>
      <Column
        header={translates('trip')}
        field="viajeImport"
        sortable
        filter
        showFilterMatchModes={false}
        filterApply={filterApplyTemplate}
        filterClear={filterClearTemplate}
        filterElement={inputTextTemplate}
      />
      <Column
        header={translates('origin')}
        field="origen"
        sortable
        filter
        showFilterMatchModes={false}
        filterApply={filterApplyTemplate}
        filterClear={filterClearTemplate}
        filterElement={inputTextTemplate}
      />
      <Column
        header={translates('arrival')}
        field="fechaLlegada"
        sortable
        filter
        showFilterMatchModes={false}
        filterApply={filterApplyTemplate}
        filterClear={filterClearTemplate}
        filterElement={(options: ColumnFilterElementTemplateOptions) => (
          <InputDateFilter options={options} />
        )}
        dataType="date"
        filterField="fechaLlegada"
      />
      <Column
        header={translates('imo')}
        field="imoImport"
        sortable
        filter
        showFilterMatchModes={false}
        filterApply={filterApplyTemplate}
        filterClear={filterClearTemplate}
        filterElement={inputTextTemplate}
      />

      <Column
        header={translates('trip')}
        field="viajeExport"
        sortable
        filter
        showFilterMatchModes={false}
        filterApply={filterApplyTemplate}
        filterClear={filterClearTemplate}
        filterElement={inputTextTemplate}
      />
      <Column
        header={translates('destination')}
        field="destino"
        sortable
        filter
        showFilterMatchModes={false}
        filterApply={filterApplyTemplate}
        filterClear={filterClearTemplate}
        filterElement={inputTextTemplate}
      />
      <Column
        header={translates('departure')}
        field="fechaSalida"
        sortable
        filter
        showFilterMatchModes={false}
        filterApply={filterApplyTemplate}
        filterClear={filterClearTemplate}
        filterElement={(options: ColumnFilterElementTemplateOptions) => (
          <InputDateFilter options={options} />
        )}
        dataType="date"
        filterField="fechaSalida"
      />
      <Column
        header={translates('exporter')}
        field="exportador"
        sortable
        filter
        showFilterMatchModes={false}
        filterApply={filterApplyTemplate}
        filterClear={filterClearTemplate}
        filterElement={inputTextTemplate}
      />
      <Column
        header={translates('imoExport')}
        field="imoExport"
        sortable
        filter
        showFilterMatchModes={false}
        filterApply={filterApplyTemplate}
        filterClear={filterClearTemplate}
        filterElement={inputTextTemplate}
      />
    </Row>
  </ColumnGroup>
);
